import type EnType from '../en-US/settings';

export default {
  'app.settings.hasNoSetting': 'No configurado',
} satisfies typeof EnType;
